<template>
    <!-- Dailog confirm modification -->
    <v-dialog
        ref="dialog"
        width="300"
        transition="dialog-transition"
    >
        <template v-slot:default="dialog">
            <v-card elevation="3">
                <v-card-title primary-title>
                    {{  $T('PersonalInfo.confirm-modification')  }}
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="dialog.value = false"
                        icon
                    >
                        <v-icon color="alert-color">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    {{  $T('PersonalInfo.are-you-sure-you-want-to-save-the-modifications?')  }}	
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="$emit('on-consent');"
                        color="secondary"
                    >
                        {{ $T('default-buttons.yes') }}
                    </v-btn>
                    <v-btn
                        @click="dialog.value = false"
                    >
                        {{ $T('default-buttons.cancel') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </template>
    </v-dialog>
</template>

<script>
export default {
    data () {
        return {
            moduleType: null
        }
    },
    methods: {
        activeConfirmDialog(){
            this.$refs.dialog.isActive = true
        },
        deactivateConfirmDialog () {
            this.$refs.dialog.isActive = false
        }
    }
}
</script>
